
import * as types from './location_types';

// Action to trigger reverse geocoding saga
export const getLocationFromCoords = (lat, lng) => ({
  type: types.GET_ADDRESS_FROM_LOC,
  payload: { lat, lng }
});

export const setLocationError = (field, error) => ({
  type: types.LOCATION_ERROR,
  payload: { field, error }
});